import { alias } from '@ember/object/computed';
import { attr } from '@ember-data/model';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
export default EmberDataBaseFragment.extend({
  kanji: attr('string'),
  kana: attr('string'),
  subareas: fragmentArray('jp-town'),
  towns: alias('subareas'),
  type: attr('string')
}).reopenClass({
  _modelNameForMigration: 'jp-city'
});